<template>
    <NuxtLayout name="malt-base-layout">
        <AdminMenu app="account" :logout="logout" />
        <KeepAlive>
            <slot />
        </KeepAlive>
        <Footer />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {AdminMenu, Footer} from '#components';
    import {useAuth} from '#imports';

    const {logout} = useAuth();
</script>
